import "./JobsContainer.less";
import * as React from "react";
import { AtListHeader } from "../../components/AtListHeader";
import { BaseForm } from "../../components/BaseForm";
import { GlobalStores, Job, JobStore, UrlFormatter } from "@atman/business";
import { IAtButtonProps } from "@atman/design-system";
import { JobCard } from "./components/JobCard";
import { RouteComponentProps, withRouter } from "react-router";
import { autorun, computed, observable } from "mobx";
import { inject, observer } from "mobx-react";

export interface IJobsContainerProps extends RouteComponentProps {
    jobStore?: JobStore;
}

@inject(GlobalStores!.jobStore)
@observer
class JobsContainerImpl extends BaseForm<IJobsContainerProps> {
    @observable private searchString: string = "";
    @observable private filteredJobs: Job[] = [];

    constructor(props) {
        super(props);

        autorun(() => {
            this.filteredJobs = this._filteredJobs;
        });
    }

    @computed private get _filteredJobs(): Job[] {
        const { jobStore } = this.props;

        if (!this.searchString) {
            return jobStore!.items;
        }

        return jobStore!.items.filter(
            (x) =>
                x.name?.toLowerCase().includes(this.searchString.toLowerCase()) ||
                x.description?.toLowerCase().includes(this.searchString.toLowerCase()),
        );
    }

    render() {
        const { history } = this.props;

        const buttons: IAtButtonProps[] = [
            {
                onClick: () => history.push(UrlFormatter.formatReactPath(`/Settings/Jobs/Create`)),
                children: "global.createJob".localize(),
            },
        ];

        return (
            <div id="JobsContainer">
                <AtListHeader
                    searchString={this.searchString}
                    onSearchStringChange={this.onTextFieldChange}
                    buttons={buttons}
                    searchInputPlaceholder={"global.searchByNameOrDescription".localize()}
                />
                <div className="cards-container">
                    {this.filteredJobs.map((x) => (
                        <JobCard job={x} key={x.id} />
                    ))}
                </div>
            </div>
        );
    }
}

export const JobsContainer = withRouter(JobsContainerImpl);
